import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from './mid_energy_icon_offline.svg'

const MidEnergyIconOffline: React.VFC<SvgIconProps> = props => <SvgIcon component={Icon} {...props} fill="currentColor" />
export default MidEnergyIconOffline
